import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store, { vxm } from "./store";
import vuetify from "./plugins/vuetify";
import ResultsGameCard from "@/components/results/results-game-card.vue";

Vue.config.productionTip = false;
Vue.component("results-game-card", ResultsGameCard);

vxm.auth.fetchProfile().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
});
